import script from "./POIDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./POIDescription.vue?vue&type=script&setup=true&lang=js"

import "./POIDescription.vue?vue&type=style&index=0&id=69a6b477&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a6b477"]])

export default __exports__